import { Database } from "../../interface";
import { observer } from "mobx-react";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { getDatabases } from "../../actions/getDatabases";
import { lang } from "../../lang";
import { Button } from "../../components/atoms/Button";
import { CenteredContent } from "../../components/atoms/CenteredContent";
import { FlexHorizontal, FlexSpacer } from "../../components/atoms/Flex";
import { Title } from "../../components/atoms/Text";
import { Table } from "../../components/molecules/Table";
import { CreateClient } from "../../components/organisms/CreateClient";
import { Template } from "../../components/organisms/Template";
import { catchEndpoint } from "../../catchEndpoint";

@observer
class AdminClientsPageBase extends React.Component<RouteComponentProps> {
    public state = {
        addPopup: false,
        databases: [] as Database[],
        clientsLoading: false
    };

    public componentDidMount() {
        this.fetchClients();
    }

    public fetchClients() {
        this.setState({
            clientsLoading: true
        });
        getDatabases()
            .then((clients: Database[] | null) => {
                this.setState({
                    databases: clients || [],
                    clientsLoading: false
                });
            })
            .catch(catchEndpoint);
    }

    public render() {
        const { databases } = this.state;
        return (
            <>
                <Template>
                    <CenteredContent>
                        <FlexHorizontal>
                            <Title>{lang.databases}</Title>
                            <FlexSpacer />
                            <div className="container_action">
                                <Button
                                    id="createclientbutton"
                                    data-at_id="open_client_popup_button"
                                    title={lang.add}
                                    style={{ marginRight: "-10px" }}
                                    onClick={() => {
                                        this.setState({
                                            addPopup: true
                                        });
                                    }}
                                />
                            </div>
                        </FlexHorizontal>
                        <Table
                            loading={this.state.clientsLoading}
                            pageSize={5}
                            columnNames={[{ id: "name", name: lang.databaseName }]}
                            data={databases}
                        />
                    </CenteredContent>
                </Template>
                {this.state.addPopup && (
                    <CreateClient
                        onClose={() => {
                            this.setState({
                                addPopup: false,
                                clientsLoading: true
                            });
                            this.fetchClients();
                        }}
                    />
                )}
            </>
        );
    }
}

const AdminClientsPage = withRouter(AdminClientsPageBase);

export { AdminClientsPage };
